<rid-demo-page [title]="'Cockpit'" previousRoute="/"> </rid-demo-page>

@if (mission(); as m) {
  <div class="fixed inset-0">
    <rid-game [studioDataPackageProvider]="dataPackageProvider" [mission]="m.uid" (missionCompleted)="onMissionCompleted($event)" />
  </div>
}
